// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__6BBzJ","noInteraction":"EventWrapper_noInteraction__127ep"};